import { render, staticRenderFns } from "./SaleInvoiceTypesTable.vue?vue&type=template&id=12598300&scoped=true&"
import script from "./SaleInvoiceTypesTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12598300",
  null
  
)

export default component.exports